import * as Joi from 'joi';
import _ from 'lodash';
import { TableVizPropVersion, } from '../types/prism';
import { TableClientStateV1Schema } from './types/v1';
import { upgraderFn as upgradeV0ToV1 } from './upgraders/v0-to-v1';
export const LATEST_CLIENT_STATE_SCHEMA = TableClientStateV1Schema;
const clientStateUpgradeChain = {
    null: {
        returnVersion: TableVizPropVersion.V1,
        upgraderFn: upgradeV0ToV1,
    },
    [TableVizPropVersion.V1]: {
        upgraderFn: (clientState, vizModel) => {
            return {
                __typename: 'TableVizProps',
                ..._.pick(clientState, [
                    'columnProperties',
                    'density',
                    'theme',
                    'showGridSummary',
                    'wrapTableHeader',
                    'showTableFooter',
                    'orderedColumnIds',
                    'widthState',
                    'tableVizPropVersion',
                ]),
            };
        },
    },
};
export function upgradeClientStateToLatestVersion(vizModel) {
    let clientState = vizModel.clientState;
    if (!_.isNil(vizModel.vizProps) &&
        !_.isEmpty(vizModel.vizProps) &&
        !_.isNil(vizModel.vizProps.tableVizPropVersion)) {
        clientState = vizModel.vizProps;
    }
    let clientStateVersion = !_.isNil(clientState.tableVizPropVersion)
        ? clientState.tableVizPropVersion
        : null;
    let currVersionUpgradeArc = clientStateUpgradeChain[clientStateVersion];
    while (!_.isNil(currVersionUpgradeArc) &&
        !_.isNil(currVersionUpgradeArc.upgraderFn)) {
        clientState = currVersionUpgradeArc.upgraderFn(clientState, vizModel);
        clientStateVersion = currVersionUpgradeArc.returnVersion || undefined;
        currVersionUpgradeArc = clientStateUpgradeChain[clientStateVersion];
    }
    Joi.assert(clientState, LATEST_CLIENT_STATE_SCHEMA);
    return clientState;
}
//# sourceMappingURL=upgrader.js.map